export const shouldShowShingleDetails = (squares: number, selectedAsphaltShingle) => {
  if (squares > 0 && selectedAsphaltShingle) {
    return 'block';
  }

  return 'none';
};

export const hasAvailableShingles = availableAsphaltShingles =>
  !(availableAsphaltShingles && availableAsphaltShingles.length !== 0);
